<template>
  <BbSelectList v-model="selectedCollection">
    <template #default>
      <BbSelectListItem v-for="item in categories" :key="`select-6-${item.id}`" :label="item.title" :value="item.id">
        <div class="status-container">
          <div class="bb-select-list-item__label">
            {{ item.title }}
          </div>
          <BbIcon v-if="selectedCollection === item.id" size="medium" name="checkmark-small" />
        </div>
      </BbSelectListItem>
    </template>
  </BbSelectList>
</template>
<script>
import { ref, toRaw, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import { isSuggestedCategory } from '~/constants/conversationModels';

import useQuickPrompts from '~/composables/useQuickPrompts';

export default {
  emits: ['select-categories'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const { categories, selectedCategories } = useQuickPrompts();

    const selectedCollection = ref(toRaw(selectedCategories.value)?.[0] || isSuggestedCategory.id);

    watch(selectedCollection, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        emit('select-categories', [newVal]);
      }
    });

    watch(
      selectedCategories,
      (newVal) => {
        const firstSelected = toRaw(newVal)?.[0];
        if (firstSelected && firstSelected !== selectedCollection.value) {
          selectedCollection.value = firstSelected;
        }
      },
      { deep: true, immediate: true },
    );

    return { t, selectedCollection, categories };
  },
};
</script>

<style scoped lang="scss">
.bb-select-list {
  padding-left: $bb-spacing-3;
  margin-bottom: -$bb-spacing-3;

  :deep(.bb-select-list__label) {
    @include bb-regular-text-styles('sm');
  }

  :deep(.el-select .el-select__wrapper) {
    border: none !important;
    text-transform: uppercase;
    width: fit-content;
    min-width: 130px;

    .el-select__suffix {
      i {
        color: $bb-primary-3 !important;
      }
    }
  }

  :deep(.el-select-dropdown__item) {
    background-color: $bb-neutral-0;
    border: none !important;

    .status-container .bb-select-list-item {
      &__label {
        display: flex;
        flex-direction: column;

        > span:nth-of-type(2) {
          @include bb-regular-text-styles('xs');
        }
      }
    }

    &.is-selected {
      color: $bb-primary-3 !important;
      background-color: $bb-neutral-0 !important;

      .status-container .bb-select-list-item {
        &__label {
          color: $bb-primary-3 !important;
          font-weight: 500 !important;
        }
      }
    }
  }
}

.status-container {
  display: flex;
  gap: $bb-spacing-1;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
</style>
